export const POST_CHECK_FACILITY = 'POST_CHECK_FACILITY'
export const POST_CHECK_FACILITY_REQUEST = 'POST_CHECK_FACILITY_REQUEST'
export const POST_CHECK_FACILITY_SUCCESS = 'POST_CHECK_FACILITY_SUCCESS'
export const POST_CHECK_FACILITY_FAILURE = 'POST_CHECK_FACILITY_FAILURE'

export const postCheckFacilityRequest = (facilityName, facilityCountry) => ({ type: POST_CHECK_FACILITY_REQUEST, payload: { facilityName, facilityCountry } })
export const postCheckFacilitySuccess = (data) => {
  return ({ type: POST_CHECK_FACILITY_SUCCESS, data })
}

export const POST_CREATE_FACILITY = 'POST_CREATE_FACILITY'
export const POST_CREATE_FACILITY_REQUEST = 'POST_CREATE_FACILITY_REQUEST'
export const POST_CREATE_FACILITY_SUCCESS = 'POST_CREATE_FACILITY_SUCCESS'
export const POST_CREATE_FACILITY_FAILURE = 'POST_CREATE_FACILITY_FAILURE'

export const postCreateFacilityRequest = (data, skipFacility) => ({ type: POST_CREATE_FACILITY_REQUEST, payload: { data, skipFacility } })
export const postCreateFacilitySuccess = (data) => {
  return ({ type: POST_CREATE_FACILITY_SUCCESS, data })
}

export const GET_EXTERNAL_SOURCE_FACILITIES = 'GET_EXTERNAL_SOURCE_FACILITIES'
export const GET_EXTERNAL_SOURCE_FACILITIES_REQUEST = 'GET_EXTERNAL_SOURCE_FACILITIES_REQUEST'
export const GET_EXTERNAL_SOURCE_FACILITIES_SUCCESS = 'GET_EXTERNAL_SOURCE_FACILITIES_SUCCESS'
export const GET_EXTERNAL_SOURCE_FACILITIES_FAILURE = 'GET_EXTERNAL_SOURCE_FACILITIES_FAILURE'

export const getExternalSourceFacilitiesRequest = () => ({ type: GET_EXTERNAL_SOURCE_FACILITIES_REQUEST })
export const getExternalSourceFacilitiesSuccess = (data) => ({ type: GET_EXTERNAL_SOURCE_FACILITIES_SUCCESS, data })
export const getExternalSourceFacilitiesFailure = (error) => ({ type: GET_EXTERNAL_SOURCE_FACILITIES_FAILURE, payload: error })

export const GET_INTERNAL_SOURCE_FACILITIES = 'GET_INTERNAL_SOURCE_FACILITIES'
export const GET_INTERNAL_SOURCE_FACILITIES_REQUEST = 'GET_INTERNAL_SOURCE_FACILITIES_REQUEST'
export const GET_INTERNAL_SOURCE_FACILITIES_SUCCESS = 'GET_INTERNAL_SOURCE_FACILITIES_SUCCESS'
export const GET_INTERNAL_SOURCE_FACILITIES_FAILURE = 'GET_INTERNAL_SOURCE_FACILITIES_FAILURE'

export const getInternalSourceFacilitiesRequest = () => ({ type: GET_INTERNAL_SOURCE_FACILITIES_REQUEST })
export const getInternalSourceFacilitiesSuccess = (data) => ({ type: GET_INTERNAL_SOURCE_FACILITIES_SUCCESS, data })
export const getInternalSourceFacilitiesFailure = (error) => ({ type: GET_INTERNAL_SOURCE_FACILITIES_FAILURE, payload: error })

export const GET_FACILITY_STATUS_REQUEST = 'GET_FACILITY_STATUS_REQUEST'
export const GET_FACILITY_STATUS_SUCCESS = 'GET_FACILITY_STATUS_SUCCESS'
export const GET_FACILITY_STATUS_FAILURE = 'GET_FACILITY_STATUS_FAILURE'
export const getFacilityStatusRequest = () => ({ type: GET_FACILITY_STATUS_REQUEST })
export const getFacilityStatusSuccess = (data) => ({ type: GET_FACILITY_STATUS_SUCCESS, data })
export const getFacilityStatusFailure = () => ({ type: GET_FACILITY_STATUS_FAILURE })

export const CANCEL_ACTIVITY_LIST_POLL = 'CANCEL_ACTIVITY_LIST_POLL'
export const CANCEL_STUDY_LIST_POLL = 'CANCEL_STUDY_LIST_POLL'
export const CANCEL_IR_STUDY_LIST_POLL = 'CANCEL_IR_STUDY_LIST_POLL'
export const CANCEL_WORK_LIST_POLL = 'CANCEL_WORK_LIST_POLL'
export const CANCEL_STUDY_ACTIVITY_POLL = 'CANCEL_STUDY_ACTIVITY_POLL'
export const CANCEL_STUDY_SHARE_LIST_POLL = 'CANCEL_STUDY_SHARE_LIST_POLL'

export const cancelActivityListPolling = () => ({ type: CANCEL_ACTIVITY_LIST_POLL })
export const cancelStudyListPolling = () => ({ type: CANCEL_STUDY_LIST_POLL })
export const cancelIRStudyListPolling = () => ({ type: CANCEL_IR_STUDY_LIST_POLL })
export const cancelWorkListPolling = () => ({ type: CANCEL_WORK_LIST_POLL })
export const cancelStudyActivityPolling = () => ({ type: CANCEL_STUDY_ACTIVITY_POLL })